/**
 * @file
 */
(function ($) {
  "use strict";
  Drupal.behaviors.eitiTheme = {
    attach: function (context, settings) {
      $(once("eitiMenuToggle", "#menu--toggle", context))
        .on("click", function (e) {

          if ($(this).hasClass("open")) {
            $(".submenu--toggle").removeClass("open");
            $(".submenu--toggle").attr("aria-expanded", "false");
            $(".child-menu").removeClass("open");
            $(this).attr("aria-expanded", "false");
          } else {
            $(this).attr("aria-expanded", "true");
          }

          $(this).toggleClass("open");
          $("#main-menu").toggleClass("open");
        });

      $(once("eitiSubMenuToggle", ".submenu--toggle", context))
        .on("click", function (e) {
          $(".child-menu").removeClass("open");

          if ($(this).hasClass("open")) {
            $(".submenu--toggle").removeClass("open");
            $(this).attr("aria-expanded", "false");
            if ($(this).hasClass("pure--toggle")) {
              $(this).next(".child-menu").removeClass("open");
              $(this)
                .next(".child-menu")
                .find(".child-menu")
                .removeClass("open");
            } else {
              $(this).parent().next(".child-menu").removeClass("open");
              $(this)
                .parent()
                .next(".child-menu")
                .find(".child-menu")
                .removeClass("open");
              $(this)
                .parent()
                .next(".child-menu")
                .find(".submenu--toggle")
                .removeClass("open")
                .attr("aria-expanded", "false");
            }
          } else {
            $(".submenu--toggle").removeClass("open");
            $(this).addClass("open");
            $(this).attr("aria-expanded", "true");
            if ($(this).hasClass("pure--toggle")) {
              $(this).next(".child-menu").addClass("open");
            } else {
              $(this).parent().next(".child-menu").addClass("open");
            }

            $(this)
              .parent()
              .parent("li")
              .siblings()
              .find(".submenu--toggle")
              .removeClass("open")
              .attr("aria-expanded", "false");
            $(this)
              .parent()
              .parent("li")
              .siblings()
              .find(".child-menu")
              .removeClass("open");
          }
        });

      $(window).scroll(function () {
        if ($(window).scrollTop() > 10) {
          $("#header").addClass("header--shrink");
        } else {
          $("#header").removeClass("header--shrink");
        }
      });

      $(".button--rotate-filters")
        .off()
        .on("click", function (e) {
          e.preventDefault();
          $(this).toggleClass("open-filters");
          $(".filter-group-body").slideToggle(500);
        });

      /* Masonry */

      var Masonry = require("masonry-layout");

      var msnryGrid = document.getElementsByClassName("masonry-grid");
      if (msnryGrid.length > 0) {
        var msnry = new Masonry(msnryGrid[0], {
          // options...
          itemSelector: ".grid-item",
          percentPosition: true,
          horizontalOrder: true,
        });

        $("#masonry-layout")
          .off()
          .on("click", function (e) {
            e.preventDefault();
            if (!$(this).hasClass("active")) {
              $(this).addClass("active");
              $("#list-layout").toggleClass("active");
              $(".masonry-grid").removeClass("list");
              msnry.layout();
            }
          });
        $("#list-layout")
          .off()
          .on("click", function (e) {
            e.preventDefault();
            if (!$(this).hasClass("active")) {
              $(this).addClass("active");
              $("#masonry-layout").toggleClass("active");
              $(".masonry-grid").addClass("list");
              msnry.layout();
            }
          });
      }
      /*
        // Attach action to Drupal Ajax Views event
        $(document).once('eitiAjaxViews').ajaxSuccess(function (event, data) {
          if (drupalSettings && drupalSettings.views && drupalSettings.views.ajaxViews) {

            var ajaxViews = drupalSettings.views.ajaxViews;
            Object.keys(ajaxViews || {}).forEach(function (i) {
              if ((ajaxViews[i]['view_name'] == 'publications' || ajaxViews[i]['view_name'] == 'news_and_events') &&  ajaxViews[i]['view_display_id'] == 'block_1') {

              }
            });

          }
        });*/

      //smooth anchors scrolling
      $(document).on("click", 'a[href^="#"]', function (event) {
        if ($.attr(this, "href").indexOf("reference-") === 1) {
          event.preventDefault();

          if (!$("#references").next(".accordion").hasClass("active")) {
            $("#references").next(".accordion").addClass("active");
            $("#references")
              .next(".accordion")
              .attr("aria-expanded", "true")
              .next(".accordion-panel")
              .addClass("show");
          }

          var refNum = $.attr(this, "href").split("reference-");
          var ref = $("#references")
            .next(".accordion")
            .next(".accordion-panel")
            .find("ol li:nth-child(" + refNum[1] + ")");

          $("html, body").animate(
            {
              scrollTop: $(ref).offset().top - 100,
            },
            1000
          );
        } else if (
          $.attr(this, "href").indexOf("tabs-") !== 1 &&
          $.attr(this, "href") !== '#main' &&
          $.attr(this, "href") !== "#"
        ) {
          event.preventDefault();

          var paddingTop = 100;

          $("html, body").animate(
            {
              scrollTop: $($.attr(this, "href")).offset().top - paddingTop,
            },
            1000
          );
        }
      });

      window.addEventListener(
        "scroll",
        function (event) {
          var top =
            window.scrollY || //Modern Way (Chrome, Firefox)
            window.pageYOffset ||
            document.documentElement.scrollTop;

          var scrollTopElements = document.querySelectorAll(".scrolltop");
          // if at least one does, loop over the returned elements and init
          if (scrollTopElements.length) {
            for (var x = 0; x < scrollTopElements.length; x++) {
              if (top > 100) {
                scrollTopElements[x].classList.add("visible");
              } else {
                scrollTopElements[x].classList.remove("visible");
              }
            }
          }
        },
        false
      );

      // check if .scroll-top exists before running function
      var scrollTopElements = document.querySelectorAll(".scrolltop");
      // if at least one does, loop over the returned elements and init
      if (scrollTopElements.length) {
        for (var x = 0; x < scrollTopElements.length; x++) {
          // scroll top function
          scrollTopElements[x].addEventListener(
            "click",
            function (e) {
              e.preventDefault();

              function scrollTo(element, to, duration) {
                if (duration <= 0) return;
                var difference = to - element.scrollTop;
                var perTick = (difference / duration) * 10;

                setTimeout(function () {
                  element.scrollTop = element.scrollTop + perTick;
                  if (element.scrollTop === to) return;
                  scrollTo(element, to, duration - 10);
                }, 10);
              }

              var scrollElement =
                document.body.scrollTop > 0
                  ? document.body
                  : document.documentElement;
              scrollTo(scrollElement, 0, 600);
              //scrollTo(document.body, 0, 600);
            },
            false
          );
        }
      }

      //Publications archive year filter
      $("[id^=edit-year]").on("change", function (e) {
        var year = $(this).val();
        if (year === "all") {
          $("[id^=edit-publication-date-min]").val("");
          $("[id^=edit-publication-date-max]").val("");
        } else {
          var startYear = year + "-01-01";
          var endYear = year + "-12-31";

          $("[id^=edit-publication-date-min]").val(startYear);
          $("[id^=edit-publication-date-max]").val(endYear);
        }
      });
    },
  };

  Drupal.behaviors.eitiAccordion = {
    attach: function (context, settings) {
      var acc = document.getElementsByClassName("accordion");
      var i;

      function checkAccExpanded(accVal) {
        var x = accVal.getAttribute("aria-expanded");
        if (x == "true") {
          x = "false";
        } else {
          x = "true";
        }
        accVal.setAttribute("aria-expanded", x);
      }

      for (i = 0; i < acc.length; i++) {
        acc[i].onclick = function () {
          this.classList.toggle("active");
          checkAccExpanded(this);
          this.nextElementSibling.classList.toggle("show");
        };

        acc[i].addEventListener("keyup", function (event) {
          if (event.keyCode === 13) {
            this.classList.toggle("active");
            checkAccExpanded(this);
            this.nextElementSibling.classList.toggle("show");
          }
        });
      }
    },
  };

  Drupal.behaviors.eitiHighlightSearchTerm = {
    attach: function (context, settings) {
      function getHighlightParameter(name) {
        var url = decodeURI(location.href);
        var name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(url);
        return results == null ? null : results[1];
      }
      function decodeURIComponentSafe(s) {
        if (!s) {
          return s;
        }
        return decodeURIComponent(s.replace(/%(?![0-9][0-9a-fA-F]+)/g, "%25"));
      }

      $(once("eitiHighlight", document, context))
        .each(function () {
          var highlightTerm = getHighlightParameter("highlightTerm");
          if (highlightTerm && highlightTerm.length > 0) {
            highlightTerm.trim();

            var Mark = require("./mark.js");
            var instance = new Mark(document.querySelector("article"));
            var keyword = decodeURIComponentSafe(
              highlightTerm.replace(/\+/g, "%20")
            );

            instance.mark(keyword, {
              element: "mark",
              className: "highlightTextClass",
              separateWordSearch: false,
            });
          }
        });
    },
  };

  Drupal.behaviors.eitiTabs = {
    attach: function (context, settings) {
      if ($(".tabbed--content").length > 0) {
        $(".tabbed--content").each(function (index) {
          if ($(this).hasClass("members-tabs")) {
            $(this).tabs({ active: 1 });
          } else {
            $(this).tabs();
          }
        });

        $(".tab--button").on("click", function () {
          var tabsContainer = $(this).parent().parent();
          var tabLinks = tabsContainer.find("a");

          var tabId = $(this).attr("data-tab");

          tabLinks.eq(tabId).trigger("click");
        });
      }

      var hash = window.location.hash.substring(1);
      if (
        hash &&
        $(".tabbed--content").length > 0 &&
        $("#" + hash).length > 0
      ) {
        var tabId = $("#" + hash)
          .parent()
          .attr("id")
          .split("tabs-");
        var tabsContainer = $("#" + hash)
          .parent()
          .parent();

        var tabLinks = tabsContainer.find("a");
        tabLinks.eq(tabId[1]).trigger("click");

        scrollTo(document.body, tabsContainer.offsetTop, 600);
      }
    },
  };

  Drupal.behaviors.eitiCarousels = {
    attach: function (context, settings) {
      jQuery.fn.extend({
        toggleOwl: function (selector, options, destroy) {
          return this.each(function () {
            $(this)
              .find(selector)
              .filter(function () {
                return $(this).parent().is(":visible");
              })
              .owlCarousel(options);

            $(this).on("tabsactivate", function (event, ui) {
              var target = $(ui.newPanel).find(selector);
              if (!target.data("owlCarousel")) {
                var owl = target.owlCarousel(options).data("owlCarousel");
              }
            });
            /*if(destroy === true){
                  $(this).on('hide.bs.tab', function(event){
                    var target = $(event.target.getAttribute('href')).find(selector);
                    if(target.data('owl.carousel')){
                      target.data('owl.carousel').destroy();
                    }
                  });
                }*/
          });
        },
      });

      if ($(".members-carousel>li").length > 0) {
        $(".members-tabs").toggleOwl(".members-carousel", {
          nav: true,
          dots: false,
          margin: 15,
          responsive: {
            0: {
              items: 1,
              margin: 0,
            },
            600: {
              items: 2,
            },
            1000: {
              items: 3,
            },
            1200: {
              items: 4,
            },
          },
        });
        /*$('.members-carousel').owlCarousel({
            nav:true,
            dots:false,
            margin:15,
            responsive:{
                0:{
                    items:1,
                    margin:0
                },
                600:{
                    items:2
                },
                1000:{
                    items:3
                },
                1200:{
                    items:4
                }
            }

          });*/
      }

      if ($(".timeline-carousel>div").length > 0) {
        $(".timeline-carousel").owlCarousel({
          nav: true,
          dots: false,
          margin: 15,
          responsive: {
            0: {
              items: 2,
              margin: 0,
            },
            600: {
              items: 3,
            },
            1000: {
              items: 6,
            },
          },
        });

        $(".carousel-layout")
          .off()
          .on("click", function (e) {
            e.preventDefault();
            if (!$(this).hasClass("active")) {
              $(this).addClass("active");
              $(this).next(".list-layout").removeClass("active");
              $(this).parent().next(".timeline-carousel").removeClass("list");
              $(this)
                .parent()
                .next(".timeline-carousel")
                .find(".owl-nav")
                .removeClass("disable");
            }
          });
        $(".list-layout")
          .off()
          .on("click", function (e) {
            e.preventDefault();
            if (!$(this).hasClass("active")) {
              $(this).addClass("active");
              $(this).prev(".carousel-layout").removeClass("active");
              $(this).parent().next(".timeline-carousel").addClass("list");
              $(this)
                .parent()
                .next(".timeline-carousel")
                .find(".owl-nav")
                .addClass("disable");
            }
          });
      }
    },
  };

   Drupal.behaviors.eitiContactForm = {
    attach: function (context, settings) {
        const requiredFields = document.getElementsByClassName("required");
        const emailValidate = document.getElementsByClassName("email-validate");
        //const messageSuccess = document.getElementById("form-message-success");
        let i;

        const submitForm = document.getElementById("contact-form-submit");

        if (submitForm) {
          submitForm.addEventListener("click", function (e) {
            let fieldsError = 0;
            //e.preventDefault();
            for (i = 0; i < requiredFields.length; i++) {
              let messageField = requiredFields[i].nextElementSibling;

              //messageSuccess.classList.remove("show");

              if (requiredFields[i].value.trim().length == 0) {
                if (messageField && messageField.classList.contains("form-message--error")) {
                  messageField.classList.add("show");
                  fieldsError++;
                }
              } else {
                messageField.classList.remove("show");
                fieldsError = 0;
              }
            }

            if (fieldsError == 0) {
              return true;
            }
            else {
              return false;
            }
          });
        }
    },
  };

  Drupal.behaviors.eitiAccessibility = {
    attach: function (context, settings) {
      $(".accessibility--control").click(function (e) {
        var accessibilityFeature = $(this).attr("data-accessibility-feature");
        var accessibilityUnit = $(this).attr("data-accessibility-unit");
        if (accessibilityFeature === "fontSize") {
          $("body").css("font-size", accessibilityUnit + "em");
          $("body").removeClass("font__1 font__125 font__15");
          $("body").addClass("font__" + accessibilityUnit.replace(".", ""));
        } else if (accessibilityFeature === "colourContrast") {
          $("body").removeClass("theme__soft theme__blue theme__hivis");
          $("body").addClass("theme__" + accessibilityUnit);
        }
        eraseCookie(accessibilityFeature);
        createCookie(accessibilityFeature, accessibilityUnit, 365);
      });

      var textCookie = readCookie("fontSize");
      if (textCookie) {
        $("body").css("font-size", textCookie + "em");
        $("body").addClass("font__" + textCookie.replace(".", ""));
      }
      var contrastCookie = readCookie("colourContrast");
      if (contrastCookie) {
        $("body").addClass("theme__" + contrastCookie);
      }

      //cookie functions http://www.quirksmode.org/js/cookies.html
      function createCookie(name, value, days) {
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          var expires = "; expires=" + date.toGMTString();
        } else var expires = "";
        document.cookie = name + "=" + value + expires + "; path=/";
      }
      function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === " ") c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length, c.length);
        }
        return null;
      }
      function eraseCookie(name) {
        createCookie(name, "", -1);
      }
      //cookie functions
    },
  };

  Drupal.behaviors.eitiGoogleEvents = {
    attach: function (context, settings) {
      //Downloads events
      // Attach mousedown, keyup, touchstart events to document only and catch
      // clicks on all elements.
      $(document.body).on("mousedown keyup touchstart", function (event) {
        if (typeof ga === "function") {
          // Catch the closest surrounding link of a clicked element.
          $(event.target)
            .closest("a,area")
            .each(function () {
              // Is the clicked URL internal?
              if (isInternal(this.href)) {
                // Skip 'click' tracking, if custom tracking events are bound.
                if ($(this).is(".colorbox")) {
                  // Do nothing here. The custom event will handle all tracking.
                  // console.info('Click on .colorbox item has been detected.');
                }
                // Is download tracking activated and the file extension configured
                // for download tracking?
                else if (isDownload(this.href)) {
                  // Download link clicked.
                  ga("send", {
                    hitType: "event",
                    eventCategory: "Downloads",
                    eventAction: getDownloadExtension(this.href).toUpperCase(),
                    eventLabel: getPageUrl(this.href),
                    transport: "beacon",
                  });
                }
              } else {
                if ($(this).is("a[href^='mailto:'],area[href^='mailto:']")) {
                  // Mailto link clicked.
                  ga("send", {
                    hitType: "event",
                    eventCategory: "Mails",
                    eventAction: "Click",
                    eventLabel: this.href.substring(7),
                    transport: "beacon",
                  });
                } else if (this.href.match(/^\w+:\/\//i)) {
                  var trackCrossDomains = [];
                  if (!isCrossDomain(this.hostname, trackCrossDomains)) {
                    // External link clicked / No top-level cross domain clicked.
                    ga("send", {
                      hitType: "event",
                      eventCategory: "Outbound links",
                      eventAction: "Click",
                      eventLabel: this.href,
                      transport: "beacon",
                    });
                  }
                }
              }
            });
        }
      });

      /**
       * Check whether the hostname is part of the cross domains or not.
       *
       * @param {string} hostname
       *   The hostname of the clicked URL.
       * @param {array} crossDomains
       *   All cross domain hostnames as JS array.
       *
       * @return {boolean} isCrossDomain
       */
      function isCrossDomain(hostname, crossDomains) {
        return $.inArray(hostname, crossDomains) > -1 ? true : false;
      }

      /**
       * Check whether this is a download URL or not.
       *
       * @param {string} url
       *   The web url to check.
       *
       * @return {boolean} isDownload
       */
      function isDownload(url) {
        var trackDownloadExtensions =
          "7z|aac|arc|arj|asf|asx|avi|bin|csv|doc(x|m)?|dot(x|m)?|exe|flv|gif|gz|gzip|hqx|jar|jpe?g|js|mp(2|3|4|e?g)|mov(ie)?|msi|msp|pdf|phps|png|ppt(x|m)?|pot(x|m)?|pps(x|m)?|ppam|sld(x|m)?|thmx|qtm?|ra(m|r)?|sea|sit|tar|tgz|torrent|txt|wav|wma|wmv|wpd|xls(x|m|b)?|xlt(x|m)|xlam|xml|z|zip|odt|ods";
        var isDownload = new RegExp(
          "\\.(" + trackDownloadExtensions + ")([?#].*)?$",
          "i"
        );
        return isDownload.test(url);
      }

      /**
       * Check whether this is an absolute internal URL or not.
       *
       * @param {string} url
       *   The web url to check.
       *
       * @return {boolean} isInternal
       */
      function isInternal(url) {
        var isInternal = new RegExp("^(https?)://" + window.location.host, "i");
        return isInternal.test(url);
      }

      /**
       * Check whether this is a special URL or not.
       *
       * URL types:
       *  - gotwo.module /go/* links.
       *
       * @param {string} url
       *   The web url to check.
       *
       * @return {boolean} isInternalSpecial
       */
      function isInternalSpecial(url) {
        var isInternalSpecial = new RegExp("(/go/.*)$", "i");
        return isInternalSpecial.test(url);
      }

      /**
       * Extract the relative internal URL from an absolute internal URL.
       *
       * Examples:
       * - http://mydomain.com/node/1 -> /node/1
       * - http://example.com/foo/bar -> http://example.com/foo/bar
       *
       * @param {string} url
       *   The web url to check.
       *
       * @return {string} getPageUrl
       *   Internal website URL.
       */
      function getPageUrl(url) {
        var extractInternalUrl = new RegExp(
          "^(https?)://" + window.location.host,
          "i"
        );
        return url.replace(extractInternalUrl, "");
      }

      /**
       * Extract the download file extension from the URL.
       *
       * @param {string} url
       *   The web url to check.
       *
       * @return {string} getDownloadExtension
       *   The file extension of the passed url. e.g. 'zip', 'txt'
       */
      function getDownloadExtension(url) {
        var trackDownloadExtensions =
          "7z|aac|arc|arj|asf|asx|avi|bin|csv|doc(x|m)?|dot(x|m)?|exe|flv|gif|gz|gzip|hqx|jar|jpe?g|js|mp(2|3|4|e?g)|mov(ie)?|msi|msp|pdf|phps|png|ppt(x|m)?|pot(x|m)?|pps(x|m)?|ppam|sld(x|m)?|thmx|qtm?|ra(m|r)?|sea|sit|tar|tgz|torrent|txt|wav|wma|wmv|wpd|xls(x|m|b)?|xlt(x|m)|xlam|xml|z|zip|odt|ods";
        var extractDownloadextension = new RegExp(
          "\\.(" + trackDownloadExtensions + ")([?#].*)?$",
          "i"
        );
        var extension = extractDownloadextension.exec(url);
        return extension === null ? "" : extension[1];
      }
    },
  };
})(jQuery);
